import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { MobileNestedList } from "./MobileNestedList";
import { ChristieInsuranceLogoWhite } from "../../../assets/icons/ChristieInsuranceLogoWhite";

export const MobileNav = ({
  activeId,
  handleActiveId,
  navData,
}: {
  activeId: string | null;
  handleActiveId: (id: string | null) => void;
  navData: Queries.kontent_item_homepage_elements;
}) => {
  const { navigation_menu, navigation_menu_button_link } = navData;
  const phone = navData?.phone?.value;
  const email = navData?.email?.value;
  const buttonLink = navigation_menu_button_link
    ?.value?.[0] as Queries.kontent_item_internal_link;
  const buttonLabel = buttonLink?.elements?.label?.value;
  return (
    <div
      className={`fixed overflow-auto right-0 bottom-0 z-70 inset-y-0 bg-slate-500 text-white py-4 px-6 w-full max-w-lg flex flex-col  ${
        activeId ? "translate-x-0" : "translate-x-full"
      } transform ease-out duration-300`}
    >
      <div className="flex justify-between items-center mt-3">
        <div className="bg-lime-500 py-4 px-6 w-auto -ml-6 mr-6">
          <ChristieInsuranceLogoWhite className="w-full" />
        </div>

        <button
          onClick={() => handleActiveId(null)}
          className="text-white p-2 flex items-center justify-end ml-auto hover:bg-red-600"
        >
          <XMarkIcon className="w-7 h-7 font-bold" />
          <span className="sr-only">Close Menu</span>
        </button>
      </div>
      {/* LIST */}
      <nav
        id="nav-primary-sm"
        role="navigation"
        aria-label="Primary Navigation"
        className="mt-3"
      >
        <ul className="text-xl">
          {/* ADD DYNAMIC URL */}
          {[...(navigation_menu?.value ?? [])].map((item, idx) => (
            <MobileNestedList
              item={item}
              key={idx}
              activeId={activeId}
              handleActiveId={handleActiveId}
            />
          ))}
          {buttonLink && buttonLabel && (
            <li className="py-2 border-b border-white/10">
              <a
                href={
                  (
                    buttonLink?.elements?.linked_page
                      ?.value?.[0] as Christie.KontentItemWithUrl
                  )?.url
                }
                className="relative font-bold flex items-center px-4 py-2 [ hover:bg-lime-500 ] text-balance"
                onClick={() => handleActiveId(null)}
              >
                {buttonLabel}
              </a>
            </li>
          )}
        </ul>
      </nav>
      <div className="py-2 flex gap-4">
        {phone && (
          <div className="py-2 flex items-center px-4 flex-1 gap-x-6">
            <a
              href={"tel:" + phone}
              className="text-lg pr-2 font-semibold flex items-center gap-2"
            >
              <PhoneIcon className="w-5 h-5 mt-0.5" />
            </a>
          </div>
        )}
        {email && (
          <div className="py-2 flex items-center px-4 flex-1 gap-x-6">
            <a
              href={"mailto:" + email}
              className="text-lg pr-2 font-semibold flex items-center gap-2"
            >
              <EnvelopeIcon className="w-5 h-5 mt-0.5" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
